<template>
	<v-dialog v-model="dialog" max-width="600px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="#1A237E" class="text-lowercase" dark small v-on="on">sell franchise</v-btn>
		</template>
		<v-card v-if="!loading">
			<v-card-title class="pt-6">
				<span class="subtitle-2">Parameters of 
					<span class="accentColor">franchise</span>
				</span>
			</v-card-title>
			<v-card-text class="black--text">
				<v-container grid-list>
					<div v-if="canSelling">
					<v-form v-model="valid" ref="form" validation>
						<v-row>
							<v-col cols="12" sm="12" md="12">
							<v-select dense
								v-model="franchise"
								:items="items"
								item-text="name"
								attach
								color="#1A237E"
								item-color="#1A237E"
								label="select franchise"
								@change="onceMore()"
								:rules="requiredRules">
							</v-select>
						</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-text-field
									color="#1A237E"
									label="Franchise cost"
									v-model.number="franchiseCost"
									name="franchiseCost"
									type="text"
									:rules="numberRules"
									@change="onceMore">
								</v-text-field>
							</v-col>
							<v-col cols="12" sm="6" md="4">
								<v-text-field
									color="#1A237E"
									label="Franchise fee"
									v-model.number="franchiseFee"
									name="franchiseFee"
									type="text"
									:rules="numberRules"
									@change="onceMore">
								</v-text-field>
							</v-col>
						</v-row>
					</v-form>
					</div>
					<div v-else>
						<v-row justify="center" class="text-center mx-2">You can't sell the franchise this year</v-row>
					</div>
				</v-container>
				<v-row justify="center" class="error mx-2">{{ error }}</v-row>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="#1A237E" text
					class="text-capitalize" 
					@click="closeDialog">
					Decline
				</v-btn>
				<v-btn color="#1A237E" text
					class="text-capitalize"
					:disabled="!canSelling || Boolean(error)"
					@click="addChannel">
					Confirm
				</v-btn>
			</v-card-actions>
		</v-card>	
		<div v-else class="text-center">
			<loader></loader>
		</div>
	</v-dialog>
</template>

<script>
	import Loader from '../../layouts/Loader.vue'

	export default {
		props: ['outlets', 'gameId', 'round', 'company'],
		data () {
			return	{
				dialog: false,
				valid: false,
				error: '',
				franchise: '',
				franchiseCost: 0,
				franchiseFee: 0,
				requiredRules: [v => !!v || 'this field is required'],
				numberRules: [
					v => !!v || 'this field is required',
					v => /^[+]?[1-9]/.test(v) || 'it\'s expected number'
				]
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			canSelling () {
				const sales = this.outlets.filter(outlet => outlet.salesUnits !== 0)
				return Boolean(this.outlets.length > 0 && sales.length > 0)
			},
			channelParams () {
				return this.$store.getters.channelParams
			},
			items () {
				const frs = []
				this.outlets.forEach(outlet => {
					const name = outlet.name.split(' - ')
					frs.push({name: (name[0]+ ' - franchise'), trademarks: outlet.trademarks})
				})
				return frs
			}
		},
		methods: {
			onceMore () {
				this.error = ''
			},
			async addChannel () {
				if (this.$refs.form.validate()) {

					const item = this.items.find(it => it.name === this.franchise)

					const cov = this.channelParams[2].marketCoverage 

					const chan = {
						name: this.franchise,
						start: this.round,
						type: 2,
						numbers: 0,
						franchiseCost: this.franchiseCost,
						franchiseFee: this.franchiseFee,
						trademarks: item.trademarks,
						company: this.company,
						coverage: cov
					}
					//console.log(chan)
					try {
						//addCanel 
						await this.$store.dispatch('addChannel', {
							gameId: this.gameId,
							round: this.round,
							channel: chan
						})
						this.closeDialog ()					
					}
					catch (error) {
						throw error
					}
				}
				else {
					this.error = 'Enter all params correctly, please'
				}
			},
			closeDialog () {
				//reset
				this.dialog = false
				this.error = ''
			}
		},
		components: {Loader}
	}
</script>
<style>
	.error{
		color: white
	}
</style>